///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'button[windeTransparent]',
    standalone: false
})
export class TransparentButtonDirective {
    @HostBinding('class') buttonClass = 'winde-button winde-button-with-text winde-transparent';
    @HostBinding('type') buttonType = 'button';
}
